import http from 'plugins/axios';

export default {
    getContractSymbolConfigList(data) {
        return http.get({
            url: '/admin/contract/symbolConfig/list',
            data
        });
    },

    synchronizeAllSymbol(data) {
        return http.post({
            url: '/admin/contract/symbolConfig/synchronizeAllSymbol',
            data,
            dataType: 'form'
        });
    },

    displaySymbol(data) {
        return http.post({
            url: '/admin/contract/symbolConfig/display',
            data,
            dataType: 'form'
        });
    },

    canCreateOrder(data) {
        return http.post({
            url: '/admin/contract/symbolConfig/canCreateOrder',
            data,
            dataType: 'form'
        });
    },

    canCancelOrder(data) {
        return http.post({
            url: '/admin/contract/symbolConfig/canCancelOrder',
            data,
            dataType: 'form'
        });
    },

    canRebate(data) {
        return http.post({
            url: '/admin/contract/symbolConfig/rebate',
            data,
            dataType: 'form'
        });
    },

    canSyncTrade(data) {
        return http.post({
            url: '/admin/contract/symbolConfig/syncTrade',
            data,
            dataType: 'form'
        });
    },

    getContractTransferList(data) {
        return http.get({
            url: '/admin/contract/transfer/listByPage',
            data
        });
    },

    transferRetry(data) {
        return http.post({
            url: '/admin/contract/transfer/transferRetry',
            data,
            dataType: 'form'
        });
    },

    getUniversalTransferRecord(data) {
        return http.get({
            url: '/admin/contract/transfer/findById',
            data
        });
    },

    getContractBinanceTransfer(data) {
        return http.get({
            url: '/admin/contract/transfer/findBinanceInfoById',
            data
        });
    },

    transferCount(data) {
        return http.get({
            url: '/admin/contract/transfer/transferCount',
            data
        });
    },

    updateRecordId(data) {
        return http.post({
            url: '/admin/contract/transfer/updateRecordId',
            data,
            dataType: 'form'
        });
    },


    getOpenOrders(data) {
        return http.get({
            url: '/admin/contract/order/openOrders',
            data
        });
    },

    getForceOrders(data) {
        return http.get({
            url: '/admin/contract/order/forceOrders',
            data
        });
    },

    getAllOrders(data) {
        return http.get({
            url: '/admin/contract/order/allOrders',
            data
        });
    },

    getUserTrades(data) {
        return http.get({
            url: '/admin/contract/order/userTrades',
            data
        });
    },

    getAccountForUSDT(data) {
        return http.get({
            url: '/admin/contract/user/accountForUSDT',
            data
        });
    },
    getAccountForCoin(data) {
        return http.get({
            url: '/admin/contract/user/accountForCoin',
            data
        });
    },

    commissionRebateCount(data) {
        return http.get({
            url: '/admin/contract/count/commissionRebateCount',
            data
        });
    },

    mainAccountBalance(data) {
        return http.get({
            url: '/admin/contract/count/mainAccountBalance',
            data
        });
    },

    balanceSnapshot(data) {
        return http.get({
            url: '/admin/contract/count/balanceSnapshot',
            data
        });
    },

    updateFeeAdjustment(data) {
        return http.post({
            url: '/admin/contract/symbolConfig/updateFeeAdjustment',
            data,
            dataType: 'form'
        });
    },

    balanceSnapshotCount(data) {
        return http.get({
            url: '/admin/contract/count/balanceSnapshotCount',
            data
        });
    },

    tradeList(data) {
        return http.get({
            url: '/admin/contract/count/tradeList',
            data
        });
    },

    balanceExport(data) {
        return http.post({
            url: '/admin/contract/count/balanceExport',
            data,
            dataType: 'form',
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json'
            }
        })
    },

    transferExport(data) {
        return http.post({
            url: '/admin/contract/transfer/transferExport',
            data,
            dataType: 'form',
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json'
            }
        })
    },

    exportTradeList(data) {
        return http.post({
            url: '/admin/contract/count/exportTradeList',
            data,
            dataType: 'form',
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json'
            }
        })
    },

    transfer(data) {
        return http.post({
            url: '/admin/contract/transfer/transfer',
            data,
            dataType: 'form'
        })
    }
};
